import React from 'react'

import dynamic from 'next/dynamic'
import {usePagination} from 'react-instantsearch'
import {useAlgoliaContext} from '../context/AlgoliaContext'

const Pagination = dynamic(() => import('./Pagination'), {ssr: false})

export default function CustomPagination() {
  const {page} = useAlgoliaContext()
  const {nbPages} = usePagination()

  return <Pagination page={page + 1} maxPage={nbPages} />
}
